import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
/**
 * @name androidstudio
 */
import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';
export var androidstudioInit = function androidstudioInit(options) {
  var _ref = options || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? [] : _ref$styles;
  return createTheme({
    theme: theme,
    settings: _extends({
      background: '#282b2e',
      foreground: '#a9b7c6',
      caret: '#00FF00',
      selection: '#343739',
      selectionMatch: '#343739',
      lineHighlight: '#343739'
    }, settings),
    styles: [{
      tag: [t.keyword, t.deleted, t.className],
      color: '#cc7832'
    }, {
      tag: [t.number, t.literal, t.derefOperator],
      color: '#6897bb'
    }, {
      tag: [t.link, t.variableName],
      color: '#629755'
    }, {
      tag: [t.comment, t.quote],
      color: 'grey'
    }, {
      tag: [t.meta, t.documentMeta],
      color: '#bbb529'
    }, {
      tag: [t.string, t.propertyName, t.attributeValue],
      color: '#6a8759'
    }, {
      tag: [t.heading, t.typeName],
      color: '#ffc66d'
    }, {
      tag: [t.attributeName],
      color: '#a9b7c6'
    }, {
      tag: [t.emphasis],
      fontStyle: 'italic'
    }].concat(_toConsumableArray(styles))
  });
};
export var androidstudio = androidstudioInit();